import script from "./H3Display.vue?vue&type=script&lang=ts&setup=true"
export * from "./H3Display.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__